<p-menu
  #menu1
  [model]="itemsOptions"
  [popup]="true"
  class="custom-menu-more-options"
></p-menu>
<div
  class="w-full flex flex-row justify-between items-center px-[22px] py-4 fixed top-0 left-0 right-0 z-50 bg-white"
>
  <div class="flex flex-row items-center gap-2">
    <lib-global-button
      [type]="'default'"
      [icon]="'pi pi-bars '"
      (click)="sidebarVisible = true"
      onKeyPress=""
    />
    <img
      src="assets/images/brand/logo-nav.svg"
      alt=""
      class="w-[181px] h-[49.30px] max-[540px]:hidden"
    />
  </div>

  <p-menu #menu2 [popup]="true" [model]="options" appendTo="body"></p-menu>

  <div class="flex flex-row items-center gap-2">
    <p-avatar
      class="h-12 flex items-center"
      image="https://primefaces.org/cdn/primeng/images/demo/avatar/onyamalimba.png"
      shape="circle"
      size="large"
      (click)="menu2.toggle($event)"
      onkeypress=""
    />
  </div>
</div>

@if (currentUserRole() === UserRole.admin) {
  <div
    class="flex flex-wrap fixed bottom-0 left-0 right-0 z-50 bg-neutral-200 py-[9px] px-[25px] justify-between max-[460px]:justify-around max-[460px]:gap-1 max-[372px]:px-[10px]"
  >
    <div
      class="flex flex-col py-[2px] px-1 items-center cursor-pointer"
      [routerLink]="'/admin/institutions'"
    >
      <i class="pi pi-building text-brand-primary"></i>
      <span class="text-label text-brand-primary" i18n>Instituciones</span>
    </div>
    <div
      class="flex flex-col py-[2px] px-1 items-center cursor-pointer"
      [routerLink]="'/admin/users'"
    >
      <i class="pi pi-user text-brand-primary"></i>
      <span class="text-label text-brand-primary" i18n>Usuarios</span>
    </div>

    <div
      class="flex flex-col py-[2px] px-1 items-center cursor-pointer"
      (click)="menu1.toggle($event)"
      onkeypress
    >
      <i class="pi pi-ellipsis-v text-brand-primary"></i>
      <span class="text-label text-brand-primary" i18n>Más</span>
    </div>
  </div>
}
<p-sidebar [(visible)]="sidebarVisible">
  <ng-template pTemplate="header">
    <img src="assets/images/brand/logo-nav.svg" alt="" />
  </ng-template>
  <ng-template pTemplate="content">
    <div class="flex flex-col gap-[14px] mt-7">
      @for (link of items; track $index) {
        <lib-menu-item [text]="link.name" [routerRedirect]="link.route" />
      }
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-center">
      <img src="assets/images/brand/bid-logo.svg" alt="" />
    </div>
  </ng-template>
</p-sidebar>

<div class="w-full">
  <p-sidebar
    [blockScroll]="true"
    [showCloseIcon]="false"
    [(visible)]="showNotification"
    position="bottom"
    class="noti-sidebar"
  >
    <app-overlay-notifications />
  </p-sidebar>
</div>

<div class="min-[600px]:w-[361px]">
  <p-overlayPanel #op (onHide)="onHide()">
    <app-overlay-notifications />
  </p-overlayPanel>
</div>
